import type { AuthUser } from 'entities/auth/model/types'

const ACCESS_TOKEN_KEY = 'auth_access_token'
const REFRESH_TOKEN_KEY = 'auth_refresh_token'
const AUTH_USER_KEY = 'auth_user'
const MPULSE_TOKEN_KEY = 'mpulse_token'

let authBootstrapInProgressCount = 0
let authBootstrapResolvers: Array<() => void> = []

export function getAccessToken(): string | null {
  return localStorage.getItem(ACCESS_TOKEN_KEY)
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY)
}

export function setAuthTokens(tokens: { access: string; refresh: string }) {
  localStorage.setItem(ACCESS_TOKEN_KEY, tokens.access)
  localStorage.setItem(REFRESH_TOKEN_KEY, tokens.refresh)
}

export function setAuthTokensFromBackend(tokens: { access_token: string; refresh_token: string }) {
  setAuthTokens({
    access: tokens.access_token,
    refresh: tokens.refresh_token,
  })
}

export function getMpulseToken(): string | null {
  return localStorage.getItem(MPULSE_TOKEN_KEY)
}

export function setMpulseToken(token: string) {
  localStorage.setItem(MPULSE_TOKEN_KEY, token)
}

export function clearMpulseToken() {
  localStorage.removeItem(MPULSE_TOKEN_KEY)
}

export function getAuthUser(): AuthUser | null {
  const raw = localStorage.getItem(AUTH_USER_KEY)
  if (!raw) return null

  try {
    return JSON.parse(raw) as AuthUser
  } catch {
    localStorage.removeItem(AUTH_USER_KEY)
    return null
  }
}

export function setAuthUser(user: AuthUser) {
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user))
}

export function clearAuthTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  localStorage.removeItem(REFRESH_TOKEN_KEY)
  localStorage.removeItem(AUTH_USER_KEY)
}

export function hasAnyAuthToken() {
  return Boolean(getAccessToken() || getRefreshToken())
}

export function hasMpulseToken() {
  return Boolean(getMpulseToken())
}

export function redirectToAuth() {
  if (window.location.pathname !== '/auth') {
    window.location.assign('/auth')
  }
}

export function startAuthBootstrap() {
  authBootstrapInProgressCount += 1
}

export function finishAuthBootstrap() {
  if (authBootstrapInProgressCount === 0) {
    return
  }

  authBootstrapInProgressCount -= 1
  if (authBootstrapInProgressCount > 0) {
    return
  }

  const resolvers = authBootstrapResolvers
  authBootstrapResolvers = []
  for (const resolve of resolvers) {
    resolve()
  }
}

export function isAuthBootstrapInProgress() {
  return authBootstrapInProgressCount > 0
}

export function waitForAuthBootstrap(): Promise<void> {
  if (!isAuthBootstrapInProgress()) {
    return Promise.resolve()
  }

  return new Promise<void>((resolve) => {
    authBootstrapResolvers.push(resolve)
  })
}
